const yup = require("yup");

// Schema for createcollegerules
const createPageGroup = yup.object({
  pagegroup: yup.string().required("Page group is required"),
  link: yup.string().required("Link is required"),
  name: yup.string().required("Name is required"),
  title: yup.string().required("Title is required"),
  visible: yup.boolean().required("Visible is required"),
});

module.exports = {
  createPageGroup,
};
